var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2474 0C24.1732 0 22.4974 1.67578 22.4974 3.75V5.84766C14.0013 7.19531 7.49738 14.5547 7.49738 23.4375V27.3516C7.49738 32.6719 5.68097 37.8398 2.36457 41.9883L0.618473 44.1797C-0.0612142 45.0234 -0.19012 46.1836 0.27863 47.1562C0.74738 48.1289 1.73175 48.75 2.80988 48.75H49.6849C50.763 48.75 51.7474 48.1289 52.2161 47.1562C52.6849 46.1836 52.556 45.0234 51.8763 44.1797L50.1302 42C46.8138 37.8398 44.9974 32.6719 44.9974 27.3516V23.4375C44.9974 14.5547 38.4935 7.19531 29.9974 5.84766V3.75C29.9974 1.67578 28.3216 0 26.2474 0ZM26.2474 11.25H27.1849C33.9114 11.25 39.3724 16.7109 39.3724 23.4375V27.3516C39.3724 32.9648 41.0013 38.4375 44.0247 43.125H8.47004C11.4935 38.4375 13.1224 32.9648 13.1224 27.3516V23.4375C13.1224 16.7109 18.5833 11.25 25.3099 11.25H26.2474ZM33.7474 52.5H26.2474H18.7474C18.7474 54.4922 19.5325 56.4023 20.9388 57.8086C22.345 59.2148 24.2552 60 26.2474 60C28.2396 60 30.1497 59.2148 31.556 57.8086C32.9622 56.4023 33.7474 54.4922 33.7474 52.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.fffb727ca5656a66e0ff18952609b189.svg";
export { ForwardRef as ReactComponent };